"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sheet = exports.SheetBody = exports.SheetHeader = void 0;
var tslib_1 = require("tslib");
var classnames_1 = (0, tslib_1.__importDefault)(require("classnames"));
var react_1 = (0, tslib_1.__importStar)(require("react"));
var react_dom_1 = require("react-dom");
var styled_components_1 = (0, tslib_1.__importStar)(require("styled-components"));
var theme_1 = require("../../theme");
var icon_button_1 = require("../icon-button");
var padding_1 = require("../padding");
var SheetHeader = function (_a) {
    var onToggle = _a.onToggle;
    return (react_1.default.createElement(padding_1.Padding, { left: 48, right: 48, top: 32 },
        react_1.default.createElement(icon_button_1.IconButton, { type: "close", onClick: function (e) {
                e.preventDefault();
                onToggle(false);
            }, testId: "sheet-close-icon" })));
};
exports.SheetHeader = SheetHeader;
var SheetBody = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement(padding_1.Padding, { left: 48, right: 48 }, children));
};
exports.SheetBody = SheetBody;
function Sheet(props) {
    var isOpen = props.isOpen, onToggle = props.onToggle, children = props.children, _a = props.overlay, overlay = _a === void 0 ? true : _a, _b = props.overlayOpacity, overlayOpacity = _b === void 0 ? 0.57 : _b, width = props.width, innerRef = props.innerRef, _c = props.hideOnClickOutside, hideOnClickOutside = _c === void 0 ? false : _c, _d = props.anchor, anchor = _d === void 0 ? 'right' : _d;
    (0, react_1.useLayoutEffect)(function () {
        if (!isOpen)
            return function () { };
        var handler = function (e) {
            if (e.key === 'Escape') {
                onToggle(false);
            }
        };
        document.body.addEventListener('keydown', handler);
        return function () { return document.body.removeEventListener('keydown', handler); };
    }, [onToggle]);
    (0, react_1.useLayoutEffect)(function () {
        if (!overlay)
            return function () {
                return undefined;
            };
        if (isOpen) {
            document.body.style.paddingRight = hasScrollbar(document.body) ? '15px' : '0';
            document.body.style.overflow = 'hidden';
        }
        return function () {
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        };
    }, [isOpen, overlay]);
    var overlayClasses = (0, classnames_1.default)({
        show: overlay,
    });
    var handleOnClickOutside = function (e) {
        if (!hideOnClickOutside) {
            return;
        }
        if (e.target === e.currentTarget) {
            onToggle(false);
        }
    };
    if (!isOpen) {
        return null;
    }
    return (0, react_dom_1.createPortal)(react_1.default.createElement(StyledOverlay, { overlayOpacity: overlayOpacity, className: overlayClasses, onClick: handleOnClickOutside },
        react_1.default.createElement(SheetContainer, { ref: innerRef, tabIndex: -1, role: "dialog", "data-testid": "sheet", width: anchor === 'top' || anchor === 'bottom' ? '100%' : width, anchor: anchor }, children)), document.body);
}
exports.Sheet = Sheet;
function hasScrollbar(el) {
    var overflowY = window.getComputedStyle(el).overflowY;
    if (overflowY === 'hidden')
        return false;
    return el.scrollHeight > el.offsetHeight;
}
function getAnimationFrom(anchor) {
    switch (anchor) {
        case 'left':
            return 'translateX(-20px)';
        case 'top':
            return 'translateY(-20px)';
        case 'bottom':
            return 'translateY(20px)';
        default:
            return 'translateY(20px)';
    }
}
var modalAnimation = function (anchor) { return (0, styled_components_1.keyframes)(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  from {\n    transform: ", ";\n    opacity: 0;\n  }\n  to {\n    transform: ", ";\n    opacity: 1;\n  }\n"], ["\n  from {\n    transform: ", ";\n    opacity: 0;\n  }\n  to {\n    transform: ", ";\n    opacity: 1;\n  }\n"])), getAnimationFrom(anchor), anchor === 'top' || anchor === 'bottom' ? 'translateX(0px)' : 'translateY(0px)'); };
var overlayAnimation = function (overlayOpacity) { return (0, styled_components_1.keyframes)(templateObject_2 || (templateObject_2 = (0, tslib_1.__makeTemplateObject)(["\n  from {\n    background: rgba(31, 21, 41, 0);\n  }\n  to {\n    background: rgba(31, 21, 41, ", ");\n  }\n"], ["\n  from {\n    background: rgba(31, 21, 41, 0);\n  }\n  to {\n    background: rgba(31, 21, 41, ", ");\n  }\n"])), overlayOpacity); };
var SheetContainer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = (0, tslib_1.__makeTemplateObject)(["\n  animation: ", " 200ms cubic-bezier(0.16, 0.68, 0.165, 1.3);\n  background-color: #fff;\n  box-sizing: border-box;\n  box-shadow: 0px 4px 30px rgba(38, 45, 70, 0.15);\n  position: fixed;\n  bottom: ", ";\n  top: ", ";\n  right: ", ";\n  width: ", ";\n  max-height: ", ";\n  z-index: ", ";\n  overflow: auto;\n\n  &:focus {\n    outline: none;\n  }\n"], ["\n  animation: ", " 200ms cubic-bezier(0.16, 0.68, 0.165, 1.3);\n  background-color: #fff;\n  box-sizing: border-box;\n  box-shadow: 0px 4px 30px rgba(38, 45, 70, 0.15);\n  position: fixed;\n  bottom: ", ";\n  top: ", ";\n  right: ", ";\n  width: ", ";\n  max-height: ", ";\n  z-index: ", ";\n  overflow: auto;\n\n  &:focus {\n    outline: none;\n  }\n"])), function (_a) {
    var anchor = _a.anchor;
    return modalAnimation(anchor);
}, function (_a) {
    var anchor = _a.anchor;
    return (anchor === 'top' ? 'unset' : 0);
}, function (_a) {
    var anchor = _a.anchor;
    return (anchor === 'bottom' ? 'unset' : 0);
}, function (_a) {
    var anchor = _a.anchor;
    return (anchor === 'left' ? 'unset' : 0);
}, function (_a) {
    var width = _a.width;
    return width || '684px';
}, function (_a) {
    var anchor = _a.anchor;
    return anchor === 'top' || anchor === 'bottom' ? '100%' : 'unset';
}, theme_1.zIndices.sheet);
var StyledOverlay = styled_components_1.default.div(templateObject_4 || (templateObject_4 = (0, tslib_1.__makeTemplateObject)(["\n  background: transparent;\n  z-index: ", ";\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  overflow: auto;\n  &.show {\n    background: ", ";\n    animation: ", " 100ms ease-in;\n    animation-fill-mode: both;\n  }\n"], ["\n  background: transparent;\n  z-index: ", ";\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  overflow: auto;\n  &.show {\n    background: ", ";\n    animation: ", " 100ms ease-in;\n    animation-fill-mode: both;\n  }\n"])), theme_1.zIndices.sheetOverlay, function (_a) {
    var overlayOpacity = _a.overlayOpacity;
    return "rgba(31, 21, 41, ".concat(overlayOpacity, ")");
}, function (_a) {
    var overlayOpacity = _a.overlayOpacity;
    return overlayAnimation(overlayOpacity);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map